import styled from 'styled-components';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import COLORS from '../../common/styles/color-pallete';

export const ReferWrapper = styled.div`
  background-color: ${COLORS.lightShadedGrey} !important;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const ReferAndEarnWrapper = styled.div`
  background-color: ${COLORS.lightShadedGrey};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReferralBanner = styled.div`
  display: flex;
  width: 100%;
  height: 265px;
  justify-content: center;
  background-color: ${COLORS.brandSecondary};

  .heading {
    margin-top: 50px;
    font-size: 28px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black};
    line-height: 38px;
  }
`;

export const RefferalContainer = styled.div`
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 60px;
  margin-top: -130px;
  z-index: 1;
`;

export const ReferralActivity = styled.div`
  display: flex;
  flex-direction: column;
  width: 540px;
  gap: 24px;

  .filters {
    height: 28px;
  }

  .activityText {
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
    font-size: 18px;
  }

  @media ${DEVICES.mobileXL} {
    width: 90%;
  }
`;

export const InstapointsHeadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const InstapointsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 540px;
  gap: 24px;

  .filters {
    height: 28px;
  }

  .activityText {
    font-family: ${FONT_FAMILY.hellix.bold};
    line-height: 26px;
    font-size: 18px;
  }

  @media ${DEVICES.mobileXL} {
    width: 90%;
  }
`;
export const InstapointsSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActivityText = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 26px;
  font-size: 18px;
`;
export const LeftHeader = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 26px;
  font-size: 18px;
`;
export const RightHeader = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 22px;
  font-size: 14px;
  cursor: pointer;
  color: ${COLORS.darkBlue};
`;
